import React, { FC } from 'react';

export const FacebookSmall: FC = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0398 2.22266H3.1842C2.77738 2.22568 2.44834 2.55473 2.44531 2.96155V14.8171C2.44834 15.2239 2.77738 15.553 3.1842 15.556H9.56753V10.4004H7.8342V8.38377H9.56753V6.90043C9.56753 5.17821 10.6175 4.23932 12.162 4.23932C12.6786 4.23932 13.1953 4.23932 13.712 4.3171V6.11154H12.6509C11.812 6.11154 11.6509 6.51155 11.6509 7.09488V8.37821H13.6509L13.3898 10.3949H11.6509V15.556H15.0398C15.4466 15.553 15.7756 15.2239 15.7786 14.8171V2.96155C15.7756 2.55473 15.4466 2.22568 15.0398 2.22266Z"
        fill="#000624"
      />
    </svg>
  );
};

export const InstagramSmall: FC = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12.5588" cy="5.33027" r="0.8" fill="#000624" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.57715 8.88829C5.57715 6.99757 7.10988 5.46484 9.00059 5.46484C10.8913 5.46484 12.424 6.99757 12.424 8.88829C12.424 10.779 10.8913 12.3117 9.00059 12.3117C7.10988 12.3117 5.57715 10.779 5.57715 8.88829ZM6.77832 8.88824C6.77832 10.1155 7.77324 11.1105 9.00054 11.1105C9.58991 11.1105 10.1551 10.8763 10.5719 10.4596C10.9886 10.0428 11.2228 9.47761 11.2228 8.88824C11.2228 7.66094 10.2278 6.66602 9.00054 6.66602C7.77324 6.66602 6.77832 7.66094 6.77832 8.88824Z"
        fill="#000624"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.25198 2.26179C6.96304 2.22935 7.19009 2.22168 9.00065 2.22168C10.8112 2.22168 11.0383 2.22935 11.749 2.26207C12.3021 2.27315 12.8493 2.37793 13.3673 2.57196C14.2629 2.91825 14.9709 3.62616 15.3173 4.52168C15.5113 5.03962 15.6161 5.58671 15.6272 6.13968C15.6596 6.85073 15.6673 7.07779 15.6673 8.88835C15.6673 10.6989 15.6597 10.926 15.6275 11.6367C15.6164 12.1898 15.5116 12.737 15.3176 13.255C14.9712 14.1506 14.2632 14.8587 13.3676 15.205C12.8496 15.399 12.3024 15.5038 11.7493 15.5149C11.0383 15.5473 10.8112 15.555 9.00065 15.555C7.19009 15.555 6.96304 15.5473 6.25226 15.5152C5.6992 15.5041 5.15201 15.3993 4.63398 15.2053C3.73836 14.8589 3.03034 14.1509 2.68398 13.2553C2.48995 12.7373 2.38517 12.1901 2.3741 11.637C2.34165 10.926 2.33398 10.6989 2.33398 8.88835C2.33398 7.07779 2.34165 6.85073 2.3741 6.13996C2.38517 5.58689 2.48995 5.03971 2.68398 4.52168C3.03034 3.62605 3.73836 2.91803 4.63398 2.57168C5.15193 2.37767 5.69901 2.27289 6.25198 2.26179ZM11.6945 3.4618C10.9916 3.42968 10.7807 3.42291 9.00066 3.42291V3.42285C7.2206 3.42285 7.00971 3.42968 6.30677 3.46174C5.88402 3.46677 5.46527 3.54442 5.06882 3.6913C4.48744 3.91564 4.02792 4.37518 3.8036 4.95657C3.65673 5.35302 3.57908 5.77177 3.57405 6.19452C3.54193 6.89746 3.53516 7.10835 3.53516 8.88841C3.53516 10.6685 3.54199 10.8794 3.57405 11.5823C3.57908 12.005 3.65673 12.4238 3.8036 12.8202C4.02793 13.4016 4.48745 13.8611 5.06882 14.0855C5.46527 14.2323 5.88402 14.31 6.30677 14.315C7.00966 14.3471 7.22043 14.3539 9.00066 14.3539C10.7809 14.3539 10.9917 14.3471 11.6945 14.315C12.1173 14.31 12.536 14.2323 12.9325 14.0855C13.5139 13.8611 13.9734 13.4016 14.1977 12.8202C14.3446 12.4238 14.4222 12.005 14.4273 11.5823C14.4594 10.8794 14.4662 10.6685 14.4662 8.88841C14.4662 7.10835 14.4593 6.89746 14.4273 6.19452C14.4222 5.77177 14.3446 5.35302 14.1977 4.95657C13.9734 4.37521 13.5139 3.91568 12.9325 3.69135C12.536 3.54448 12.1173 3.46683 11.6945 3.4618Z"
        fill="#000624"
      />
    </svg>
  );
};

export const LinkedInSmall: FC = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.2171 2.2217H14.5615C15.0992 2.21847 15.5409 2.64537 15.556 3.18281V14.555C15.5438 15.0938 15.1004 15.5224 14.5615 15.5161H3.2171C2.67827 15.5224 2.2348 15.0938 2.22266 14.555V3.18281C2.23775 2.64537 2.67946 2.21847 3.2171 2.2217ZM4.21701 13.5606H6.17257V7.22168H4.21701V13.5606ZM5.21717 6.33814C4.59273 6.33832 4.08225 5.84017 4.06717 5.21592C4.05618 4.90768 4.1738 4.60875 4.3919 4.39065C4.60999 4.17256 4.90893 4.05493 5.21717 4.06592C5.81983 4.10788 6.28728 4.60901 6.28728 5.21314C6.28728 5.81727 5.81983 6.3184 5.21717 6.36036V6.33814ZM11.6671 13.5219H13.6004V10.0497C13.6004 8.35526 13.2282 7.02193 11.2337 7.02193C10.4622 6.98742 9.73579 7.38598 9.3504 8.05526H9.31151V7.22193H7.46707V13.4886H9.44485V10.3497C9.44485 9.53304 9.6004 8.72193 10.6337 8.72193C11.6671 8.72193 11.6671 9.68304 11.6671 10.4219V13.5219Z"
        fill="#000624"
      />
    </svg>
  );
};
